import * as React from "react";
import { MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function Localizacao() {
  return;
}